import { IVehicleTuningShopItem } from '~/rage';
import {
	IVehicleWheelsSettings,
	VehicleTuningCategory,
	VehicleWheelsSetting,
} from '~/shared';
import { createSlice } from '../wrappers';

export interface TuningSlice {
	activeStage: 'category' | 'list' | 'wheel_settings';
	activeCategory: VehicleTuningCategory | null;
	maxCategoryIndex: number;
	activeList: IVehicleTuningShopItem[];
	activeListIndex: number | null;
	maxListIndex: number;
	wheelSettings: IVehicleWheelsSettings;
	shopItems: IVehicleTuningShopItem[];
	activeVariants: Record<string, number>;
}

const initialState: TuningSlice = {
	activeStage: 'category',
	activeCategory: null,
	maxCategoryIndex: 7,
	activeList: [] as IVehicleTuningShopItem[],
	activeListIndex: null,
	maxListIndex: 0,
	wheelSettings: {
		[VehicleWheelsSetting.FRONT_CAMBER]: 1,
		[VehicleWheelsSetting.REAR_CAMBER]: 1,
		[VehicleWheelsSetting.FRONT_OFFSET]: 1,
		[VehicleWheelsSetting.REAR_OFFSET]: 1,
		[VehicleWheelsSetting.RADIUS]: 1,
		[VehicleWheelsSetting.WIDTH]: 1,
	},
	shopItems: [],
	activeVariants: {},
};

const tuningSlice = createSlice({
	name: 'tuning',
	initialState,
	reducers: {
		setActiveStage: (state, action) => {
			state.activeStage = action.payload;
		},
		setActiveListIndex: (state, action) => {
			state.activeListIndex = action.payload;
		},
		setMaxListIndex: (state, action) => {
			state.maxListIndex = action.payload;
		},
		setActiveList: (state, action) => {
			state.activeList = action.payload;
		},
		setActiveCategory: (state, action) => {
			state.activeCategory = action.payload;
		},
		setWheelSettings: (state, action) => {
			state.wheelSettings = action.payload;
		},
		setShopItems: (state, action) => {
			state.shopItems = action.payload;
		},
		setActiveVariant: (
			state,
			action: { payload: { itemId: string; index: number } },
		) => {
			state.activeVariants[action.payload.itemId] = action.payload.index;
		},
	},
});

export const {
	setActiveStage,
	setActiveListIndex,
	setMaxListIndex,
	setActiveList,
	setActiveCategory,
	setWheelSettings,
	setShopItems,
	setActiveVariant,
} = tuningSlice.actions;

export default tuningSlice.reducer;
